import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap, map, tap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';

import { AuthService } from 'src/app/core/services/auth.service';
import { SessionActions } from './session.actions';
import { SnackbarActions } from '../../../core/store/snackbar/snackbar.actions';
import { selectUserSettings } from 'src/app/user-account/store/user-settings/user-settings.selectors';
import { UserSettingsActions } from 'src/app/user-account/store/user-settings/user-settings.actions';

@Injectable()
export class LoginEffects {
  constructor(private actions$: Actions, private authService: AuthService, private router: Router, private store: Store) {}

  getLoginStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.login_start),
        switchMap(data =>
          this.authService.login(data.userLoginData).pipe(
            map(user => SessionActions.login_success({ user })),
            catchError(error => of(SessionActions.login_fail({ error: error })))
          )
        )
      ),
    { dispatch: true }
  );

  getLoginSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.login_success),
        tap(() => this.router.navigate(['/projects']))
      ),
    { dispatch: false }
  );

  getLoginFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.login_fail),
        map(() => SnackbarActions.snackbar_open({ snackbarData: { type: 'error', message: 'User.InvalidEMailOrPassword' } }))
      ),
    { dispatch: true }
  );

  getUserStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.get_user_start),
        switchMap(() => {
          return this.authService.getUser().pipe(
            map(user => SessionActions.get_user_success({ user })),
            catchError(error => of(SessionActions.get_user_fail({ error: error })))
          );
        })
      ),
    { dispatch: true }
  );

  getUserSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.get_user_success, SessionActions.login_success),
        withLatestFrom(this.store.select(selectUserSettings)),
        map(([action, userSettings]) => {
          if (userSettings === null) {
            return UserSettingsActions.get_user_settings_start();
          } else {
            return SessionActions.no_op();
          }
        })
      ),
    { dispatch: true }
  );

  getUserFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.get_user_fail),
        tap(data => {
          throw data.error;
        })
      ),
    { dispatch: false }
  );

  logout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.logout),
        switchMap(() => {
          return this.authService.logout();
        }),
        tap(() => {
          return this.router.navigate(['/login']);
        })
      ),
    { dispatch: false }
  );
}
